<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :params="params"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/conditionals`;
    this.setLink += `/${this.id}/conditionals`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "month",
          label: "Количество месяцев",
          type: "field",
          textType: "number",
        },
        {
          col: " col-12 col-md-12",
          key: "exchange_id",
          label: "Внешний ключ",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "coefficient",
          label: "Коэфф. цены",
          type: "field",
          textType: "number",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_conditional",
      itemLink: "partners",
      setLink: "partners",
      columns: [
        {
          key: "coefficient",
          title: "Коэфф. цены",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "month",
          title: "Количество месяцев",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          // detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
